var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"top"},[_c('img',{staticClass:"itemImage",attrs:{"src":require(("@/assets/images/main/" + (_vm.item.image)))},on:{"load":_vm.onLoad}})])}
var staticRenderFns = []

export { render, staticRenderFns }